<template>
  <div class="modal modal-custom-team active">
    <div class="modal-dialog">
      <span class="icon-close" @click="closePreview"></span>
      <div class="modal-content">
        <div class="modal-body">
          <img :src="`/static-assets/images/share-images/${image}`" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["image", "closePreview"],
};
</script>